<form class="form-horizontal" [formGroup]="independentForm">
  <accordion-group [isOpen]="true">
    <span accordion-heading>
      <i class='fa fa-user'></i> Datos Generales
    </span>
    <div class="form-group row" *ngIf="!isShortFormActiveForPlan">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Nombre del Negocio</b>
          <span appRequiredAsterisk [formGroup]="independentForm" controlName="businessName"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="text" class="form-control" formControlName="businessName" [ngClass]="independentForm.controls.businessName.errors ? 'is-invalid' : 'is-valid'" [readonly]="readonly">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Ingreso </b>
          <span appRequiredAsterisk [formGroup]="independentForm" controlName="incomeAmount"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="number" class="form-control" formControlName="incomeAmount" [ngClass]="independentForm.controls.incomeAmount.errors ? 'is-invalid' : 'is-valid'" [readonly]="readonly">
          <!--  -->
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Giro o Actividad Económica</b>
          <span appRequiredAsterisk [formGroup]="independentForm" controlName="economicActivity"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <ng-select formControlName="economicActivity" [items]="economicActivities" bindLabel="description" bindValue="key" [readonly]="readonly"></ng-select>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Relación</b>
          <span appRequiredAsterisk [formGroup]="independentForm" controlName="businessRelationType"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <ng-select formControlName="businessRelationType" [items]="businessRelationTypes" bindLabel="value" bindValue="key" [readonly]="readonly"></ng-select>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>¿Desde hace cuánto se dedica?</b>
          <span appRequiredAsterisk [formGroup]="independentForm" controlName="businessRelationDate"></span>
      </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input bsDatepicker class="form-control" formControlName="businessRelationDate" [bsConfig]="{ isAnimated: true, containerClass:'theme-blue', displayOneMonthRange: true, selectFromOtherMonth:true }" [ngClass]="independentForm.controls.businessRelationDate.errors ? 'is-invalid' : 'is-valid'" [readonly]="readonly">
          <!--  -->
        </div>
      </div>
  </accordion-group>
  <accordion-group [isOpen]="true">
    <span accordion-heading>
      <i class='fa fa-map-marker'></i> Información de Ubicación
    </span>
    <div class="row">
      <div class="form-group col-md-3">
        <label class="col-form-label"><b>Pais</b>
          <span appRequiredAsterisk [formGroup]="independentForm" controlName="country"></span>
        </label>
        <ng-select formControlName="country" [items]="nationalities" bindLabel="country" bindValue="code"
          (change)="changeCountry($event)" [clearable]="false" [readonly]="readonly"></ng-select>
      </div>
      <div class="form-group col-md-3">
        <label class="col-form-label"><b>Departamento</b>
          <span appRequiredAsterisk [formGroup]="independentForm" controlName="deparment"></span>
        </label>
        <ng-select formControlName="deparment" [items]="departments" bindLabel="name" bindValue="region"
          (change)="changeDepartment($event)" [clearable]="false" [readonly]="readonly"></ng-select>
      </div>
      <div class="form-group col-md-3">
        <label class="col-form-label"><b>Ciudad</b>
          <span appRequiredAsterisk [formGroup]="independentForm" controlName="city"></span>
        </label>
        <ng-select formControlName="city" [items]="cities" bindLabel="name" bindValue="cityCode"
          (change)="changeCity($event)" [clearable]="false" [readonly]="readonly"></ng-select>
      </div>
      <div class="form-group col-md-3">
        <label class="col-form-label"><b>Colonia</b>
          <span appRequiredAsterisk [formGroup]="independentForm" controlName="neighborhood"></span>
        </label>
        <ng-select formControlName="neighborhood" [items]="neighborhoods" bindLabel="name" bindValue="code" [clearable]="false" [readonly]="readonly"></ng-select>
      </div>
    </div>
    <div class="form-group row" *ngIf="!hideStreet">
      <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Calle 1</b>
        <span appRequiredAsterisk [formGroup]="independentForm" controlName="street"></span>
      </label>
      <div class="col-10 col-md-10 col-sm-8 ">
        <input type="text" class="form-control" formControlName="street" [ngClass]="independentForm.controls.street.errors ? 'is-invalid' : 'is-valid'" [readonly]="readonly">
      </div>
    </div>
    <div class="form-group row" *ngIf="!hideStreet && !isShortFormActiveForPlan">
      <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Calle 2</b>
        <span appRequiredAsterisk [formGroup]="independentForm" controlName="street2"></span>
      </label>
      <div class="col-10 col-md-10 col-sm-8 ">
        <input type="text" class="form-control" formControlName="street2" [readonly]="readonly">
      </div>
    </div>
    <div class="form-group row" *ngIf="!hideStreet && !isShortFormActiveForPlan">
      <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Calle 3</b>
        <span appRequiredAsterisk [formGroup]="independentForm" controlName="street3"></span>
      </label>
      <div class="col-10 col-md-10 col-sm-8 ">
        <input type="text" class="form-control" formControlName="street3" [readonly]="readonly">
      </div>
    </div>
    <div class="form-group row" *ngIf="!hideStreet && !isShortFormActiveForPlan">
      <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Calle 4</b>
        <span appRequiredAsterisk [formGroup]="independentForm" controlName="street4"></span>
      </label>
      <div class="col-10 col-md-10 col-sm-8 ">
        <input type="text" class="form-control" formControlName="street4" [readonly]="readonly">
      </div>
    </div>
    <div class="form-group row" *ngIf="!hideStreet && !isShortFormActiveForPlan">
      <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Calle 5</b>
        <span appRequiredAsterisk [formGroup]="independentForm" controlName="street5"></span>
      </label>
      <div class="col-10 col-md-10 col-sm-8 ">
        <input type="text" class="form-control" formControlName="street5" [readonly]="readonly">
      </div>
    </div>
  </accordion-group>
  <accordion-group [isOpen]="true">
    <span accordion-heading>
      <i class='fa fa-phone'></i> Información de Teléfonos
    </span>
    <div class="row">
      <div class="form-group col-md-8">
        <label class="col-form-label"><b>Teléfono</b>
          <span appRequiredAsterisk [formGroup]="independentForm" controlName="companyPhone"></span>
        </label>
        <input type="text" class="form-control" formControlName="companyPhone"
          [ngClass]="independentForm.controls.companyPhone.errors ? 'is-invalid' : 'is-valid'" [mask]="currentMask"
          [showMaskTyped]="true" [readonly]="readonly">
      </div>
      <div class="form-group col-md-4" *ngIf="!isShortFormActiveForPlan">
        <label class="col-form-label"><b>Extensión</b>
          <span appRequiredAsterisk [formGroup]="independentForm" controlName="companyExtension"></span>
        </label>
        <input type="text" class="form-control" formControlName="companyExtension" [readonly]="readonly">
      </div>
    </div>
  </accordion-group>
</form>
